export async function initializeProductVariants() {
  const config = window.productVariantData || {};
  const productId = config.productId || '';
  const familyIdKeys = config.familyIdKeys || [];
  const translations = config.translations || {};
  const shopLanguage = config.shopLanguage || 'en';
  const variantCollectionId = `gid://shopify/Collection/${config.variantCollectionId}` || null;
  const familyIdValues = config.familyIdValues || [];

  const collectionData = await fetchProductVariants(variantCollectionId, familyIdKeys, familyIdValues, shopLanguage);
  if (!collectionData || !collectionData.products?.edges) {
    console.error('No product data found for collection ID:', collectionId);
    return;
  }

  const containers = document.querySelectorAll('.product-variants-container > div');

  containers.forEach(container => {
    const familyId = container.dataset.familyId;
    const metafieldKey = container.dataset.metafieldKey;
    const isIcon = container.dataset.isIcon;

    const products = [];
    collectionData.products.edges.forEach(({ node: product }) => {
      const metafields = product.metafields || [];

      const familyMetafield = metafields.find(m => m?.namespace === 'family_id' && m?.key === metafieldKey);
      if (familyMetafield) {
        const parsedFamilyValue = parseJsonSafe(familyMetafield.value);
        if (parsedFamilyValue[0]?.family_id === familyId) {
          products.push(product);
        }
      }
    });

    products.sort((a, b) => {
      const aMetafield = a.metafields?.find(m => m?.namespace === 'family_id' && m?.key === metafieldKey);
      const bMetafield = b.metafields?.find(m => m?.namespace === 'family_id' && m?.key === metafieldKey);
      const aValue = parseJsonSafe(aMetafield?.value)[0]?.characteristic_value || '0';
      const bValue = parseJsonSafe(bMetafield?.value)[0]?.characteristic_value || '0';
      return parseFloat(aValue.replace(',', '.')) - parseFloat(bValue.replace(',', '.'));
    });

    let matchingProductsHtml = '';
    products.forEach(product => {
      matchingProductsHtml += generateProductButton(product, familyId, metafieldKey, isIcon, productId);
    });

    if (matchingProductsHtml && products.length > 1) {
      // Use the translated label or fallback to metafieldKey
      const translatedLabel = translations[`family_id.${metafieldKey}`] || metafieldKey;
      container.innerHTML = `
        <div class="product-variants">
          <div class="variant-pickers">
            <variant-selects id="variant-selects-${familyId}" data-section="${familyId}">
              <fieldset class="js product-form__input product-form__input--swatch">
                <legend class="form__label">${translatedLabel}</legend>
                ${matchingProductsHtml}
              </fieldset>
            </variant-selects>
          </div>
        </div>
      `;
    }
  });
}

function generateProductButton(product, familyId, metafieldKey, isIcon, currentProductId) {
  const isSelected = product.id === currentProductId;
  const metafields = product.metafields || [];
  const familyMetafield = metafields.find(m => m.namespace === 'family_id' && m.key === metafieldKey);
  if (!familyMetafield) return '';

  const parsedFamilyValue = parseJsonSafe(familyMetafield.value);
  const characteristicValue = (() => {
    const prezentare = metafields.find(m => m?.namespace === 'prezentare' && m?.key === metafieldKey);
    const isHidden = metafields.find(m => m?.namespace === 'is_hidden' && m?.key === metafieldKey);
    const rawValue = prezentare?.value || isHidden?.value || parsedFamilyValue[0]?.characteristic_value || '';
    // Handle both arrays and strings
    const parsedValue = typeof rawValue === 'string' && rawValue.trim() ? parseJsonSafe(rawValue) : rawValue;
    return Array.isArray(parsedValue) ? parsedValue[0] || '' : parsedValue;
  })();

  const productUrl = `/products/${product.handle}`;
  const productImage = product.featuredImage?.url || '';
  const productTitle = product.title;

  if (isIcon === '1') {
    return `
            <div class="family-product ${isSelected ? 'is_selected' : ''}">
                <a class="${isSelected ? 'disable-link' : ''}" href="${productUrl}">
                    <img src="${productImage}" alt="${productTitle}">
                </a>
            </div>
        `;
  } else {
    return `
            <div class="family-product family-product-box ${isSelected ? 'is_selected' : ''}">
                <a class="${isSelected ? 'disable-link' : ''}" href="${productUrl}">
                    ${characteristicValue}
                </a>
            </div>
        `;
  }
}
